// plugins/error-handler.ts
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    // Here you can send an email to the admin
    // e.g., call an API endpoint that triggers the email
  };

  nuxtApp.hook("vue:error", (error, instance, info) => {
    // This also catches errors at the top level
    // You can send an email here as well
  });
});
